import createCache from "@emotion/cache";
import { CacheProvider } from "@emotion/react";
import { createTheme, DialogContent, DialogTitle, ThemeProvider, Typography } from "@mui/material";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./www/app";
import { RootDialog } from "./www/components";


declare global {
	export interface Window {
		readonly __purser__: Readonly<{
			ajaxUrl: string;
		}>
	}
}

export const theme = createTheme({
	typography: {
		fontFamily: "inherit",
	},
});

window.addEventListener("load", () => {
	const rootEl = document.getElementById("purserMain");
	if(!rootEl) {
		throw new Error("Missing #purserMain");
	}

	const shadow = rootEl.attachShadow({ mode: "open" });
	const shadowEl = document.createElement("div");
	shadowEl.id = "purserShadow";
	shadow.appendChild(shadowEl);

	const appEl = document.createElement("div");
	appEl.id = "purserApp";
	shadowEl.appendChild(appEl);

	const emotionCache = createCache({
		key: "css",
		prepend: true,
		container: shadowEl,
	});

	const root = createRoot(appEl);
	const app = new App();
	root.render(
		<StrictMode>
			<CacheProvider value={ emotionCache }>
				<ThemeProvider theme={ theme }>
					<RootDialog app={ app }>
						<DialogTitle>Sign-up!</DialogTitle>
						<DialogContent>
							<Typography>
								Insert sign-up form here!
							</Typography>
						</DialogContent>
					</RootDialog>
				</ThemeProvider>
			</CacheProvider>
		</StrictMode>
	);
});
